type ApiError = {
  status: number;
  data: {
    message: string;
    errors: string[];
    status: string;
  };
};

export const isApiError = (error: unknown): error is ApiError => {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    "data" in error
  );
};

export const isValidationError = (error: ApiError): boolean => {
  return (
    error.status === 400 &&
    error.data.message === "Validation error" &&
    Array.isArray(error.data.errors) &&
    error.data.status === "BAD_REQUEST"
  );
};